import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type BadgeVariant = "new" | "sale" | "soldOut" | "custom";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  children: ReactNode;
}

const variantStyles: Record<BadgeVariant, string> = {
  new: "bg-brand-gold text-white",
  sale: "bg-red-600 text-white",
  soldOut: "bg-gray-400 text-white",
  custom: "bg-brand-dark text-white",
};

export function Badge({
  variant = "custom",
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-widest",
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
